import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { ADMIN_TOKEN_KEY, APP_NAME } from "@/lib/constants";

export const WelcomePage = () => {
  // Nach dem Kauf immer sauber starten: alte Session abmelden, dann Registrieren/Anmelden zeigen.
  const goRegister = () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    window.location.href = "/app?register=1";
  };
  const goLogin = () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    window.location.href = "/app";
  };
  return (
    <div className="min-h-screen bg-[var(--brand-bg)] font-[Inter] flex items-center justify-center px-4 py-10" data-testid="welcome-page">
      <Card className="w-full max-w-xl bg-white border-[var(--brand-border)] shadow-xl overflow-hidden">
        <div className="px-8 pt-10 pb-8 text-center">
          <div
            className="mx-auto h-16 w-16 rounded-2xl flex items-center justify-center text-white mb-5"
            style={{ background: "var(--brand-primary)" }}
          >
            <CheckCircle2 className="w-9 h-9" />
          </div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-[var(--brand-primary)] mb-2">{APP_NAME}</div>
          <h1 className="font-[Playfair_Display] text-3xl font-bold text-[var(--brand-ink)] mb-3" data-testid="welcome-title">
            Vielen Dank für deinen Kauf!
          </h1>
          <p className="text-[var(--brand-muted)] leading-relaxed mb-6">
            Deine Zahlung war erfolgreich – dein Zugang steht bereit. 🎉<br />
            Lege jetzt in nur einem Schritt dein Konto an, um sofort loszulegen.
          </p>

          <div className="bg-[var(--brand-bg)] rounded-xl p-5 text-left mb-7" data-testid="welcome-steps">
            <div className="text-xs font-semibold uppercase tracking-wider text-[var(--brand-primary)] mb-3">So geht's weiter</div>
            <ol className="space-y-3 text-sm text-[var(--brand-ink)]">
              <li className="flex gap-3">
                <span className="shrink-0 h-6 w-6 rounded-full bg-[var(--brand-ink)] text-white text-xs flex items-center justify-center font-bold">1</span>
                <span>Konto anlegen mit <strong>genau der E-Mail-Adresse</strong>, mit der du gekauft hast – so wird dein Kauf automatisch erkannt.</span>
              </li>
              <li className="flex gap-3">
                <span className="shrink-0 h-6 w-6 rounded-full bg-[var(--brand-ink)] text-white text-xs flex items-center justify-center font-bold">2</span>
                <span>Eigenes Passwort festlegen – fertig, dein Tarif ist sofort freigeschaltet.</span>
              </li>
              <li className="flex gap-3">
                <span className="shrink-0 h-6 w-6 rounded-full bg-[var(--brand-primary)] text-[var(--brand-ink)] text-xs flex items-center justify-center font-bold">3</span>
                <span>Branding einrichten und dein erstes Angebot/deine erste Rechnung erstellen. ✨</span>
              </li>
            </ol>
          </div>

          <Button
            onClick={goRegister}
            className="w-full rounded-full bg-[var(--brand-primary)] hover:bg-[var(--brand-primary-dark)] text-white font-semibold py-6 text-base"
            data-testid="welcome-register-btn"
          >
            Jetzt Konto anlegen &amp; loslegen <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
          <button
            onClick={goLogin}
            className="mt-4 text-sm text-[var(--brand-muted)] hover:text-[var(--brand-ink)] hover:underline"
            data-testid="welcome-login-link"
          >
            Du hast bereits ein Konto? Hier anmelden
          </button>
          <p className="text-[11px] text-[var(--brand-muted)] mt-6">
            Du erhältst zusätzlich eine Willkommens-E-Mail mit deinem Zugangslink.
          </p>
        </div>
      </Card>
    </div>
  );
};
